import { container } from "tsyringe";
import { RentalServiceEvent } from "../../domain/events/rentalServicesEvent";
import { getCookieShopify } from "./cookieService";
/**
 * RentalServices - Represents a connection for rental services from websocket
 */
export default class BookingServices {
    /**
     * Constructor
     */
    constructor() {
        /**
         * Create message to send to socket
         * @param data Data to send
         * @param event Event to send
         * @returns Message wrapped - socketWrapperMessage
         */
        this.createMessage = (data, event, isCache, visitorId, guid, oldCar, geolocationData) => {
            if (guid) {
                data.sessionUserId = guid;
            }
            else {
                data.sessionUserId = getCookieShopify();
            }
            return {
                event: event,
                data: JSON.stringify(data),
                isCache: isCache,
                visitorId: visitorId,
                oldCar: oldCar,
                ip: "",
                geolocationData: geolocationData
            };
        };
        /**
         * Get Availability
         * @param payload Payload to send
         * @param dispatch Dispatch for connect to react state (redux)
         * @param callback Method to call when availability are received
         * @returns void
         *
         *
         * */
        this.onAvailability = (callback) => {
            // registro el evento
            return this.application.handle(RentalServiceEvent.AVAILABILITY_SEARCH_RESULT, (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                }
            });
        };
        this.emitAvailability = (payload, isCache, visitorId, oldCar, geolocationData) => {
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.USER_ANALIZER_VALIDATE, isCache, visitorId, undefined, oldCar, geolocationData));
        };
        this.emitAvailabilityByFilter = (payload, isCache, visitorId, oldCar, geolocationData) => {
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.AVAILABILITY_SEARCH, isCache, visitorId, undefined, oldCar, geolocationData));
        };
        this.getAvailability = (payload, dispatch, callback, isCache, visitorId) => {
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.USER_ANALIZER_VALIDATE, isCache, visitorId));
        };
        this.getAvailabilityByFilter = (payload, dispatch, callback, isCache, visitorId) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.AVAILABILITY_SEARCH_RESULT, (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                    registry
                        .then((solve) => {
                        // solve.unregister();
                    })
                        .catch((err) => console.log("Error to emit event ShowLoading"));
                }
            });
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.AVAILABILITY_SEARCH, isCache, visitorId));
        };
        /**
         * get availability by id
         * @param payload
         * @param dispatch
         * @param callback
      
         */
        this.getAvailabilityById = (payload, dispatch, callback, visitorId) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.AVAILABILITY_SEARCH_SINGLE_RESULT, (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                    registry
                        .then((solve) => {
                        solve.unregister();
                    })
                        .catch((err) => console.log("Error to emit event ShowLoading"));
                }
            });
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.AVAILABILITY_SEARCH_SINGLE, false, visitorId));
        };
        /**
         * validate task complet - validate if all tasks are complete
         */
        this.validateTasksComplete = (callback) => {
            // registro el evento
            return this.application.handle(RentalServiceEvent.UPDATE_TASK_STATUS, (payload) => {
                callback(payload);
            });
        };
        this.getFilters = (callback) => {
            return this.application.handle(RentalServiceEvent.AVAILABILITY_GET_FILTERS, (payload) => {
                callback(payload);
            });
        };
        this.getLocationsResults = (callback) => {
            return this.application.handle(RentalServiceEvent.LOCATIONS_RESULTS, (payload) => {
                callback(payload);
            });
        };
        /**
         * validate reservation completed - validate if resrvation process is complete.
         */
        this.validateReservationComplete = (callback) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.RESERVATION_RESULT_SUCCESS, (payload) => {
                callback(payload);
                registry
                    .then((solve) => {
                    // solve.unregister();
                })
                    .catch((err) => console.log("Error to emit event ShowLoading"));
            });
        };
        /**
         * get checkout intent
         */
        this.getCheckoutIntent = (payload, dispatch, callback) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.CHECKOUT_INTENT_RESULT, (payload) => {
                callback(payload);
                registry
                    .then((solve) => {
                    // solve.unregister();
                })
                    .catch((err) => console.log("Error to emit event ShowLoading"));
            });
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.CHECKOUT_INTENT, false));
        };
        this.getCheckoutIntentPaypal = (payload, dispatch, callback) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.CHECKOUT_INTENT_RESULT_PAYPAL, (payload) => {
                callback(payload);
                registry
                    .then((solve) => {
                    // solve.unregister();
                })
                    .catch((err) => console.log("Error to emit event ShowLoading"));
            });
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.CHECKOUT_INTENT_PAYPAL, false));
        };
        this.captureOrderPaypal = (payload, dispatch, callback) => {
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.CAPTURE_ORDER_PAYPAL, false));
            callback();
        };
        /**
         * Send Message to update offer status
         * @param payload
         * @param dispatch
         * @param ip
         */
        this.updateOfferProcessingPayment = (payload, dispatch) => {
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.UPDATE_OFFER_STATUS, true));
        };
        this.paymentComplete = (payload, dispatch, callback) => {
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.PAYMENT_COMPLETE, false));
        };
        this.searchSinglePayment = (payload, dispatch, callback, visitorId) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.AVAILABILITY_SEARCH_SINGLE_PAYMENT_RESULT, (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                    registry
                        .then((solve) => {
                        // solve.unregister();
                    })
                        .catch((err) => console.log("Error to emit event ShowLoading"));
                }
            });
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.AVAILABILITY_SEARCH_SINGLE_PAYMENT, false, visitorId, sessionStorage.getItem("guid") || undefined));
        };
        /**
         * Request baby seat quotation with real provider prices.
         * Registers a listener for the quotation result, then sends the request via WebSocket.
         * @param payload - Contains offerId, searchId, selections with seat counts, and isQuotation flag
         * @param callback - Called when the quotation response arrives
         */
        this.requestBabySeatQuotation = (payload, callback) => {
            const registry = this.application.handle(RentalServiceEvent.BABY_SEAT_QUOTATION_RESULT, (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                    registry
                        .then((solve) => {
                        // unregister after receiving the result
                    })
                        .catch((err) => console.log("Error handling baby seat quotation result"));
                }
            });
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.BABY_SEAT_QUOTATION_REQUEST, false));
        };
        this.paymentStatus = (payload, dispatch, callback) => {
            // registro el evento
            const registry = this.application.handle(RentalServiceEvent.PAYMENT_STATUS_RESULT, (payload) => {
                if (payload !== null && payload !== undefined) {
                    callback(payload);
                    registry
                        .then((solve) => {
                        // solve.unregister();
                    })
                        .catch((err) => console.log("Error to emit event ShowLoading"));
                }
            });
            // send message to socket
            this.eventBusSocket.send(this.createMessage(payload, RentalServiceEvent.PAYMENT_STATUS, false));
        };
        this.application = container.resolve("IRegisterEventServiceBus");
        this.eventBusSocket = container.resolve("IEventBusSocket");
    }
}
